export const locale = {
  lang: 'tr',
  data: {
    'AVANCES': {
      'GOSURVEY':'Ankete git',
      'GOPORTAL':'Porta saymaya git',
      'REGRESAR':'Geri vermek',
      'DESCARGAR':'İndir excel',
      'PRIMEROS':'İlk 1000',
      'SINCRONIZAR':'Sayım portalı ile senkronize edin',
      'PRODUCTO':'Produtos',
      'AGREGAR': 'Ekle',
      'FEC-LAN':' Lansman tarihi ',
      'FEC-CIE':' Kapanış tarihi ',
      'NOFEC-LAN': "Henüz bir lansman tarihi planlamadınız",
      'FEC-CIE-PROR':' Kapanış tarihi uzatıldı ',
      'CER':' Anketi Kapat ',
      'ABR':' Açık Anket ',
      'PROR':'ÖNERİLER',
      'SURVEY':'Anket: ',
      'FILE':'Cultura Go Cloud Drive: ',
      'WARNING-FECHA-GUARDAR':'Tarihli uzantılar eklediğinizden emin misiniz ',
      'SUCCESS-PRORROGA': 'Kapanış tarihi olarak değiştirildi ',
      'WARNING-CIERRE-ENCUESTA':'Anketin durumunu değiştireceğinizden emin misiniz?',
      'SUCCESS-CIERRE': 'Anket doğru şekilde değiştirildi',
      'PORCENTAJE':'Yanıtların önizlemesi: ',
      'DES':'Göstermek için tıklayın    ',
      'WARNING-BTN':'Anketiniz başlatılmadığı için şu anda bu işlemi yapmadım',
      'PROCESARRESU': 'İşlem sonuçları',
      'ETIQUETAS':{
        'ETIQUETAS': 'Sayfa başına öğeler',
        'OF': 'nın-nin',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>Kullanıcı yanıtlarının kaldırılmasını onaylamak için',
          'MESSAGE2':', metin kutusuna kullanıcı adını girin</span>',
          'MESSAGE3':'<span>Kullanıcı yanıtlarının kaldırılmasını onaylamak için, metin kutusuna kullanıcı adını girin ',
          'SALIR': 'çıkış',
          'VALIDAR': 'Kullanıcıyı onaylayın',
          'ERRORNOMBREEMPRESA': 'Girilen kullanıcının adı, silmek istediğiniz kullanıcının adı ile eşleşmiyor',
          'MENSAJE': '¿Emin misiniz?\n\nKullanıcı cevaplarını silmek üzeresiniz ',
          'CANCELAR': 'İptal etmek',
          'CONFIRMAR': 'Evet, sil',
          'SUCCES': 'Cevaplar silindi',
          'CERRAR': 'Kapat'
        },
        'MESSAGE':'¿Cevapları silmek istediğinizden emin misiniz kullanıcının',
        'RESP_SI':'Evet',
        'RESP_NO':'Hayır',
        'ACEPTAR':' Kabul etmek',
        'CANCELAR':'İptal etmek',
        'OK':'Tamam',
        'SUCCESS-DELETE':'Cevaplar başarıyla silindi',
        'ERROR-DELETE':'Ters şeyler oldu',
      },
      'PROCESAR': {
        'OK': 'İşlem başarıyla başladı',
        'NOTOK': 'İşlem başlayamadı, önce istediğiniz sonuçları ayarlamanız gerekiyor'
      },
      'INS':{
        'INS1':' nın-nin ',
        'INS2':' işbirlikçiler '
      },
      'INICIO':{
        'TITULO':'Kullanıcı anketi durumu',
        'INSTRUCCIONES':'Sol tarafta şirket tarafından satın alınan ürünler içeren bir bar var. Bunlardan birine tıklamak müşterileri yıllara göre gösterir, lütfen söz konusu ürünün anketini yapan kullanıcıların listesini gösterebilmek için birini seçin. ',
      },
      'ENCUESTA':{
        'TTITULO': 'Kullanıcı Anketi İlerlemesi ',
        'PRODUCTS':'Satın alınan ürünler',
        'LABEL01':'ad',
        'LABEL02':'Posta',
        'LABEL03':'anahtar',
        'LABEL04':'durum',
        'LABEL05':'Davetiye',
        'LABEL06':'Hatırlatma',
        'LABEL07':'Sil',
        'LABEL08':'Başla',
        'LABEL09':'Son',
        'LABEL10':'Hareketler',
        'LABEL11':'Anket işlemleri',
        'LABEL12':'Erişim anahtarı',
        'DESCARGAR':'İndiriliyor, lütfen bekleyin...',
        'BUSCAR':'Arama',
        'TITULOEXCEL':'Anket durumu',
        //r, lütfen bekleyin .... sahip olduğunuz toplam kullanıcı sayısı
        'CARGANDO':'Yükleniyo',
        'ACTIVA':'Anket etkinleştirilmedi',
        'PLACE':'Aramak istediğiniz ortak çalışanın adını yazın',
        'ACTIONS':'gizli eylemler',
        'NOUSER':'Arama bulunamadı',
        'NA':'Müsait değil',
        'ERROR':'Bu ürünün henüz bir anketi yok',
        'SUCCESS1':'Davet gönderildi',
        'SUCCESS2':'Hatırlatıcı gönderildi',
        'ERROR1':'Ters şeyler oldu',
      },
      'TITULOS':{
        'NAME':'Katılımcı adı',
        'ESTADOS':'Anket durumu',
        'FECHA1':'Başlangıç ​​tarihi',
        'FECHA2':'Anketin bitiş tarihi',
        'ESTADOS_ENC':{
          'TITULO':'Bir seçenek seçin',
          'TODO':'Hepsini Göster ',
          'ESTADO1':'Ankete henüz başlamadı',
          'ESTADO2':'Giriş yaptınız',
          'ESTADO3':'Anket devam ediyor',
          'ESTADO4':'Anket bitti',
          'ESTADO5':'Kabul Edilmedi',
          'ESTADO6':'anketi kabul ediyorum',
        }
      },
      'COLUMNAS':{
        'email':'Elektronik posta',
        'end_date':'Son tarih',
        'id_status':'Statü',
        'name':'Ad',
        'start_date':'Başlangıç ​​tarihi'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'Anket işlemleri',
        'INFO':'Sonraki adımlar size yapılabilecek eylemleri gösterir kullanıcı için',
        'ACC1':'Davetiye gönder',
        'ACC2':'Hatırlatıcıyı gönder',
        'ACC3':'Anket yanıtını silin',
      },
      'NEWCOLAB': {
        'TITULO': 'Ankete yeni katılımcı ekleyin',
        'INST_1': 'Yeni bir katılımcı eklemek için gerekli veri setlerinin her birini tamamlayın',
        'TITULO_MOD': 'Ortak çalışan verilerini değiştirin',
        'INST_1_MOD': 'Seçilen ortak çalışanın veri kümelerinin her birinde değişiklik yapabilirsiniz.',
        'INST_2': '(*) İle işaretlenmiş alanlar zorunludur',
        'WARNING1':'NOT: BU İŞBİRLİĞİNİN ANAHTARI ',
        'WARNING2':' DEĞİŞTİRİLEMEZ',
        'DATASET_1': 'Veri Kümesi 1',
        'DATASET_2': 'Veri Kümesi 2',
        'DATASET_3': 'Veri Kümesi 3',
        'DATASET_4': 'Veri Kümesi 4',
        'DATASET_5': 'Veri Kümesi 5',
        'DATASET_6': 'Veri Kümesi 6',
        'DATASET_7': 'Veri Kümesi 7',
        'REQUIRED': 'Bu alan gereklidir',
        'NEXT': 'Sonraki',
        'BACK': 'Önceki',
        'SAVE': 'Kayıt etmek',
        'ERR_OWNKEY': 'Girilen çalışan numarası zaten veritabanında kayıtlı, farklı bir tane deneyin',
        'ERR_BOSSKEY': 'Girilen patron numarası veritabanında saklanmıyor, farklı bir tane deneyin',
        'ERR_VAL_1': 'Alana girilen veriler:',
        'ERR_VAL_2': 'geçersiz karakterler içeriyor veya doğru biçimde değil',
        'GUARDANDO': 'Katılımcı bilgileri saklanıyor, lütfen bekleyin',
        'GUARDANDO_GOFLOW': 'Bilgiler saklanıyor, lütfen bekleyin.',
        'SAVE_OK': 'Yeni katılımcının bilgileri doğru şekilde saklandı',
        'MOD_OK': 'Katılımcı bilgileri başarıyla değiştirildi',
        'FORMULARIO': 'Henüz kayıt formunu doldurmadınız, gerekli tüm alanları doldurduğunuzu kontrol edin ve tekrar deneyin',
        'ACCIONES': 'Eylemleri',
        'VERACT': 'Özel eylemler',
        'LOADACT': 'Mevcut eylemler yükleniyor',
        'NOACT': 'Bu katılımcı için ek eylem gerçekleştirilemez',
        'AVAACT': 'Bu ortak çalışan için aşağıdaki eylemler gerçekleştirilebilir',
        'ACCIONLIST': {
          'modificar': 'Seçilen ortak çalışanın bilgilerini değiştirin',
          'borrar': 'Seçili ortak çalışanı sil'
        },
        'DELCOLAB': 'Seçilen ortak çalışanı bu üründen çıkarmayı onaylıyor musunuz? Not: Bu eylem geri alınamaz',
        'DEL_OK': 'Bu ortak çalışan üründen başarıyla kaldırıldı',
        'ERR_EMAIL': 'Girilen e-posta adresi zaten veritabanında kayıtlı, farklı bir tane deneyin',
        'ERR_SAMEKEY': 'Girilen patron anahtarı ve ortak çalışan anahtarı aynı, buna izin verilmiyor, farklı bir tane dene',
        'RESET_COLAB_SURVE': 'Ankete erişimi sıfırlamayı onaylıyor musunuz? ',
        'ACTU_OK': 'Doğru güncellendi',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': 'Perspektif',
        'statementID': 'reaktif kimlik',
        'dimensionL1': 'Boyut L1',
        'dimensionL2': 'Boyut L2',
        'survey_Score_OverallTI': 'GlobalTI Puan Anketi',
        'company_Country': 'Ülke Şirket',
        'cgo_Product_Name': 'Ürün adı cgo',
        'company_Name': 'Şirket Adı',
        'ranking_Year': 'Sıralama yılı',
        'survey_Respondents': 'yanıtlayanlar',
        'survey_Score_Camaraderie': 'Arkadaşlık Puanı Anketi',
        'survey_Score_Credibility': 'Güvenilirlik Puanı Anketi',
        'survey_Score_Imparciality': 'Tarafsızlık Puanı Anketi',
        'survey_Score_Pride': 'Onur Puanı Anketi',
        'survey_Score_Respect': 'Saygı Puanı Anketi',
        'survey_Score_Gestalt': 'Gestalt Puan Anketi',
        'pdf_DateCreation': 'Sertifika oluşturma tarihi',
        'WARNI_TI_DA':'Girilen değer izin verilen formata (100.00) karşılık gelmiyor',
        'WARNI_TI_DA_GRAL':'Girilen veri belirtilen formatta değil',
      },
      'FORMULARIO':{
        'fullName': 'Ad Soyad',
        'ownKey': 'Çalışan sayısı',
        'age': 'doğum yılı',
        'surveyKey': 'anket erişim anahtarı',
        'email': 'e-posta',
        'bossName': 'doğrudan patron adı',
        'bossKey': 'doğrudan patron numarası',
        'country': 'ülke',
        'location': 'yer',
        'geo_1': 'coğrafi seviye 1',
        'geo_2': 'coğrafi seviye 2',
        'geo_3': 'coğrafi seviye 3',
        'geo_4': 'coğrafi seviye 4',
        'geo_5': 'coğrafi seviye 5',
        'geo_6': 'coğrafi seviye 6',
        'geo_7': 'coğrafi seviye 7',
        'geo_8': 'coğrafi seviye 8',
        'geo_9': 'coğrafi seviye 9',
        'geo_10': 'coğrafi seviye 10',
        'geo_19': 'coğrafi seviye 19',
        'structure_1': 'yapısal seviye 1',
        'structure_2': 'yapısal seviye 2',
        'structure_3': 'yapısal seviye 3',
        'structure_4': 'yapısal seviye 4',
        'structure_5': 'yapısal seviye 5',
        'structure_6': 'yapısal seviye 6',
        'structure_7': 'yapısal seviye 7',
        'structure_8': 'yapısal seviye 8',
        'structure_9': 'yapısal seviye 9',
        'structure_10': 'yapısal seviye 10',
        'area': 'alan',
        'bUnit': 'iş ünitesi',
        'enterDate': 'şirkete giriş tarihi',
        'antiquity': 'antik dönem',
        'antiquityUS': 'Antik bize',
        'generation': 'nesil',
        'generationUS': 'bize nesil',
        'ageUS': 'yaş',
        'charge': 'şirketteki konumu veya işlevi',
        'homologado': 'şarj veya işlev onaylandı',
        'homologadoUS': 'ücret veya işlev bizi onayladı',
        'gender': 'Cinsiyet',
        'genderType': 'cinsiyet türü',
        'typeofwork': 'tazminat türü',
        'workCondition': 'çalışma şartı',
        'academico': 'akademik derece',
        'contratacion': 'sözleşme tipi',
        'situacionUS': 'çalışma durumu bize',
        'personal': 'çalışan tipi',
        'jornada': 'çalışma programı türü',
        'rotacion': 'vardiya dönüşü yapar',
        'phone': 'ortak çalışanın telefonu',
        'extension': 'ortak çalışanın doğrudan uzantısı',
        'cellphone': 'işbirlikçinin cep telefonu',
        'native': 'anadil',
        'answer': 'Cevap',
        'other_1': 'diğerleri 1',
        'other_2': 'diğerleri 2',
        'other_3': 'diğerleri 3',
        'other_4': 'diğerleri 4',
        'other_5': 'diğerleri 5',
        'other_6': 'diğerleri 6',
        'other_7': 'diğerleri 7',
        'other_8': 'diğerleri 8',
        'other_9': 'diğerleri 9',
        'other_10': 'diğerleri 10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'Sayım portalı ile senkronize ediliyor, lütfen bekleyin....',
        'SUCCESS':'Senkronizasyon doğru şekilde tamamlandı'
      }
    },
  }
};
